import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';

/* eslint-disable consistent-return */
var networkMessages = ['Network request failed', 'Failed to fetch', 'NETWORK_ERROR', 'NETWORK', 'fetch'];
var checkForNetworkError = function checkForNetworkError(error) {
  var reg = new RegExp(networkMessages.join('|'), 'i');
  return reg.test(error.message);
};
var Poller = /*#__PURE__*/function () {
  function Poller() {
    _classCallCheck(this, Poller);
    _defineProperty(this, "isCancelled", false);
    _defineProperty(this, "promise", null);
  }
  _createClass(Poller, [{
    key: "poll",
    value: function poll(asyncFn) {
      var _this = this;
      var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 180000;
      var endTime = Date.now() + timeout;
      var run = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
          var isNetworkError, result, error;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!_this.isCancelled) {
                    _context.next = 2;
                    break;
                  }
                  return _context.abrupt("return");
                case 2:
                  isNetworkError = false;
                  _context.prev = 3;
                  _context.next = 6;
                  return asyncFn();
                case 6:
                  result = _context.sent;
                  if (!result) {
                    _context.next = 9;
                    break;
                  }
                  return _context.abrupt("return", resolve(result));
                case 9:
                  _context.next = 16;
                  break;
                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](3);
                  isNetworkError = checkForNetworkError(_context.t0);
                  if (isNetworkError) {
                    _context.next = 16;
                    break;
                  }
                  return _context.abrupt("return", reject(_context.t0));
                case 16:
                  if (!isNetworkError) {
                    _context.next = 19;
                    break;
                  }
                  setTimeout(run, interval, resolve, reject);
                  return _context.abrupt("return");
                case 19:
                  if (!(endTime > Date.now())) {
                    _context.next = 23;
                    break;
                  }
                  setTimeout(run, interval, resolve, reject);
                  _context.next = 26;
                  break;
                case 23:
                  error = new Error('Poll timed out');
                  error.code = 'POLL_TIMEOUT';
                  return _context.abrupt("return", reject(error));
                case 26:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[3, 11]]);
        }));
        return function run(_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();
      this.promise = new Promise(run);
      return this;
    }
  }, {
    key: "then",
    value: function then() {
      var _this$promise;
      this.promise = (_this$promise = this.promise).then.apply(_this$promise, arguments);
      return this;
    }
  }, {
    key: "catch",
    value: function _catch() {
      var _this$promise2;
      this.promise = (_this$promise2 = this.promise)["catch"].apply(_this$promise2, arguments);
      return this;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.isCancelled = true;
    }
  }]);
  return Poller;
}();

export { Poller as default };
